import colors, { withOpacity } from '../../utils/colors';
import type { InputColors } from './types';

export const INPUT_HEIGHT = 56;
export const INPUT_MULTILINE_HEIGHT = 80;
export const INPUT_BORDER_WIDTH = 1;
export const INPUT_PADDING_HORIZONTAL = 15;
export const INPUT_MARGIN_BOTTOM = 15;

type GetInputsColors = (params: { error?: string | boolean; hasValue: boolean; isFocused: boolean }) => InputColors;

export const getInputColors: GetInputsColors = ({ error, hasValue, isFocused }) => {
  const defaultColors: InputColors = {
    background: colors.transparent,
    border: colors.neutral100,
    icon: colors.neutral100,
    placeholder: withOpacity(colors.neutral100, 0.7),
    textColor: colors.neutral100,
  };

  const inputColors = defaultColors;

  if (hasValue) {
    inputColors.placeholder = colors.neutral50;
  }

  if (error) {
    inputColors.border = colors.error100;
    inputColors.icon = colors.error100;
    inputColors.placeholder = colors.error100;
  }

  if (isFocused) {
    inputColors.border = colors.orange100;
    inputColors.icon = colors.neutral100;
    inputColors.placeholder = colors.orange100;
  }

  return inputColors;
};
